export interface TimePicker {
  title: string;
  time: string;
  hour?: number;
  minute?: number;
  hourLabel?: string;
  minuteLabel?: string;
  meridian?: string;
}
